import {ReactComponent as TickIcon} from "../../ui/icon/Tick.svg";

import "./_sign-flow-success-view.scss";

import {
  V2SwapExecution,
  convertFromBaseUnits,
  getAssetOutFromSwapQuote
} from "@tinymanorg/tinyman-js-sdk";

import ClipboardButton from "../../../component/clipboard/button/ClipboardButton";
import ContainerButton from "../../../component/button/container/ContainerButton";
import Typography from "../../../component/typography/Typography";
import {
  useSwapFormDispatch,
  useSwapFormState
} from "../../../swap/form/context/SwapFormContext";
import {useSwapFlowDispatch} from "../../../swap/flow/context/SwapFlowContext";
import {SwapFlowView} from "../../../swap/flow/context/SwapFlowContext.types";
import {getDisplayTextForTxnID} from "./SignFlowSuccessView.utils";
import {createPairNameFromConstituents} from "../../../asset/util/assetUtils";
import LinkButton from "../../../component/button/link/LinkButton";
import {generatePeraExplorerLink} from "../../integrations/pera-explorer/peraExplorerUtils";

interface SignFlowSuccessViewProps {
  data: V2SwapExecution;
}

function SignFlowSuccessView({data}: SignFlowSuccessViewProps) {
  const swapFormState = useSwapFormState();
  const dispatchSwapFormAction = useSwapFormDispatch();
  const {assetIn, assetOut, quote} = swapFormState;
  const {amount: assetOutAmount} = getAssetOutFromSwapQuote(quote!);
  const {
    assetIn: {amount: spentAmount},
    txnID
  } = data;
  const dispatchSwapFlowAction = useSwapFlowDispatch();

  return (
    <div className={"is-centered sign-flow-success-view"}>
      <div className={"is-centered sign-flow-success-view__text-container"}>
        <div className={"is-centered sign-flow-success-view__tick-icon-container"}>
          <TickIcon />
        </div>

        <Typography
          as={"h2"}
          tabIndex={0}
          variant={"title"}
          customClassName={"sign-flow-success-view__text-container__title"}>
          {`${createPairNameFromConstituents([
            assetIn.asset!,
            assetOut.asset!
          ])} swap completed`}
        </Typography>

        <Typography
          tabIndex={0}
          customClassName={"sign-flow-success-view__description"}
          textColor={"text-gray"}>
          {"You received "}

          <Typography
            as={"span"}
            variant={"body"}
            fontWeight={"medium"}
            textColor={"text-gray"}>
            {`${convertFromBaseUnits(
              swapFormState.assetOut.asset!.decimals,
              assetOutAmount
            )} ${assetOut.asset?.unit_name}`}
          </Typography>

          {" in exchange for "}

          <Typography
            as={"span"}
            variant={"body"}
            fontWeight={"medium"}
            textColor={"text-gray"}>
            {`${convertFromBaseUnits(assetIn.asset!.decimals, spentAmount)} ${
              assetIn.asset?.unit_name
            }`}
          </Typography>
        </Typography>
      </div>

      <div className={"has-space-between sign-flow-success-view__button-container"}>
        <ClipboardButton
          aria-label={"Copy transaction ID"}
          textToCopy={txnID}
          customClassName={
            "sign-flow-success-view__button-container__copy-address-button"
          }>
          {getDisplayTextForTxnID(txnID)}
        </ClipboardButton>

        <LinkButton
          aria-label={"View transaction on AlgoExplorer"}
          href={generatePeraExplorerLink("txn-id", txnID)}
          customClassName={
            "font-weight--medium sign-flow-success-view__button-container__algo-explorer-button"
          }>
          {"PeraExplorer"}
        </LinkButton>
      </div>

      <ContainerButton
        aria-label={"Go back to swap"}
        onClick={goBackToSwap}
        customClassName={"sign-flow-success-view__back-to-swap-button"}>
        {"Go back to swap"}
      </ContainerButton>
    </div>
  );

  function goBackToSwap() {
    dispatchSwapFlowAction({type: "SET_VIEW", view: SwapFlowView.Form});

    dispatchSwapFormAction({type: "RESET_FORM", isReady: true});
  }
}

export default SignFlowSuccessView;
